var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Key component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconKey extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4927 2.88556C18.7856 2.59267 19.2605 2.59267 19.5534 2.88556L22.6749 6.0071C22.9678 6.29999 22.9678 6.77487 22.6749 7.06776C22.382 7.36065 21.9071 7.36065 21.6142 7.06776L19.023 4.47655L16.5719 6.92765L18.7729 9.12863C19.0658 9.42152 19.0658 9.89639 18.7729 10.1893C18.48 10.4822 18.0051 10.4822 17.7122 10.1893L15.5113 7.98831L10.8719 12.6277C11.5606 13.5381 11.9691 14.6723 11.9691 15.9019C11.9691 18.9021 9.53698 21.3342 6.5368 21.3342C3.53662 21.3342 1.10449 18.9021 1.10449 15.9019C1.10449 12.9017 3.53662 10.4696 6.5368 10.4696C7.7665 10.4696 8.90076 10.8782 9.81124 11.567L14.9745 6.40373L14.9809 6.39728L14.9874 6.39091L18.4927 2.88556ZM9.27367 13.0783C8.56578 12.392 7.60062 11.9696 6.5368 11.9696C4.36505 11.9696 2.60449 13.7302 2.60449 15.9019C2.60449 18.0737 4.36505 19.8342 6.5368 19.8342C8.70855 19.8342 10.4691 18.0737 10.4691 15.9019C10.4691 14.8382 10.0467 13.8731 9.36055 13.1652C9.34507 13.1521 9.33 13.1382 9.31537 13.1235C9.30074 13.1089 9.28684 13.0938 9.27367 13.0783Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconKey.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconKey.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconKey.prototype, "size", void 0);
if (customElements.get('cat-icon-key') === undefined) {
    customElements.define('cat-icon-key', BlocksIconKey);
}
